import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { toCSS } from '../../helpers/styles';
import { sendToParent_AC, touchPanelButtonClicked_AC } from '../../store/actions/executor.actions';

interface IButtonProps {
  classType?: string;
  blink: string;
  enable: string;
  height: string;
  id: string;
  isToggleButton: string;
  label: string;
  visible: string;
  width: string;
  hSpacing: string | number;
  playSound: any;
}
const Button = styled.button<IButtonProps>`
  display: inline-flex;
  visibility: ${({ visible }) => (visible === 'true' ? 'visible' : 'hidden')};
  box-sizing: border-box !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left-color: rgb(187, 187, 187);
  border-top-color: rgb(187, 187, 187);
  border-right-color: rgb(0, 0, 0);
  border-bottom-color: rgb(0, 0, 0);
  font-family: 'Barlow-Regular';
  font-size: 12px;
  font-weight: bold;
  padding: 0;
  :focus {
    outline: none;
  }
  :active {
    border-left-color: rgb(0, 0, 0);
    border-top-color: rgb(0, 0, 0);
    border-right-color: rgb(187, 187, 187);
    border-bottom-color: rgb(187, 187, 187);
  }
  ${({ blink }) => `
        background: ${blink === 'true' ? '#FFF' : 'transparent'};
        color: ${blink === 'true' ? '#000' : '#FFF'};
    `}
  cursor: pointer;
  border-radius: 3px;
  border-width: 2px;
  ${({ height, width, hSpacing }) => `
        height: ${toCSS(height)};
        width: ${toCSS(width)};
        margin: 0px ${toCSS(hSpacing)};
    `}
`;

const TouchPanelButton: React.FunctionComponent<IButtonProps> = (props) => {
  const { label, enable, id, playSound } = props;
  const labelLines = label.split('\n').slice(0, -1);
  const lastLabel = label.split('\n').slice(-1);
  const dispatch = useDispatch();
  const doClick = () => {
    playSound();
    dispatch(
      sendToParent_AC(touchPanelButtonClicked_AC(id, 'S80_TSD_DEFINITION'))
    );
  };
  return (
    <Button onClick={doClick} disabled={enable === 'false'} {...props}>
      {labelLines.map((l) => (
        <React.Fragment>
          {l}
          <br />
        </React.Fragment>
      ))}
      {lastLabel}
    </Button>
  );
};

export default TouchPanelButton;
